// Hideo - tag state of Hooks, Sources and Saved videos, shared by their pages, the tag pickers and the bars, and the tag being renamed in the "Manage tags" lists (TagList.vue). It is reactive.
// Also the tag labels of the cards with the bar's projects (tagBadges).
import { defineStore } from 'pinia'
import { reactive } from 'vue'
import type { TagGroup } from '../data/types'
import { barProjects, tagBadgesHtml } from '../features/tags'
import { useDataStore } from './data'
import { useProjectsStore } from './projects'

interface TagState {
  /** Tag chosen in the bar ('' = all; Saved videos: TAG_NONE = without tags, src/features/tags.ts) */
  filter: string
  /** Where the "new tag" field is open */
  adding: '' | 'bar' | 'picker'
  /** Project of a tag created from the bar with "All projects" ('' = the default one) */
  newPid: string
  /** Text of the page's search (Hooks; kept between visits) */
  query: string
}

export const useTagStore = defineStore('tags', () => {
  const state = reactive<Record<TagGroup, TagState>>({
    src: { filter: '', adding: '', newPid: '', query: '' },
    hook: { filter: '', adding: '', newPid: '', query: '' },
    saved: { filter: '', adding: '', newPid: '', query: '' }
  })
  /** The tag being renamed in "Manage tags" or Settings (one at a time, in any list): group, project, tag ('' = none)
   *  and the name typed so far */
  const rename = reactive({ k: 'src' as TagGroup, pid: '', tag: '', value: '' })
  /** Starts renaming a tag (tag '' = stops) */
  function editTag(k: TagGroup, tag: string, pid: string) { Object.assign(rename, { k, pid, tag, value: tag }) }
  return { state, rename, editTag }
})

/** Tag labels of a card with their colour and icon; HTML. Without pid, the look of the first project of the bar (the
 *  active one, or every project with "All projects") that has one. It reads and normalises the data at every call: the
 *  Hooks and Sources pages call tagBadgesHtml (src/features/tags.ts) with the data and bar they already have */
export function tagBadges(tags: string[], k: TagGroup, pid?: string): string {
  const d = useDataStore().getData()
  return tagBadgesHtml(d, tags, k, pid, barProjects(d, useProjectsStore().active()).map(p => p.id))
}
